import type { NTree } from '../interface';

enum Record {
  None,
  Start,
  End
}

export function calcRangeKeys({
  treeData,
  expandedKeys,
  startKey,
  endKey,
  fieldNames = {
    title: 'title',
    key: 'key',
    children: 'children'
  }
}: {
  treeData: NTree.IDataNode[];
  expandedKeys: NTree.TKey[];
  startKey?: NTree.TKey;
  endKey?: NTree.TKey;
  fieldNames?: NTree.IFieldNames;
}): NTree.TKey[] {
  const keys: NTree.TKey[] = [];
  let record: Record = Record.None;

  if (startKey && startKey === endKey) {
    return [startKey];
  }
  if (!startKey || !endKey) {
    return [];
  }

  function matchKey(key: NTree.TKey) {
    return key === startKey || key === endKey;
  }

  traverseNodesKey(treeData, fieldNames, (key: NTree.TKey | null) => {
    if (key === null) return false;
    if (record === Record.End) return false;

    if (matchKey(key)) {
      // Match test
      keys.push(key);

      if (record === Record.None) {
        record = Record.Start;
      } else if (record === Record.Start) {
        record = Record.End;
        return false;
      }
    } else if (record === Record.Start) {
      // Append selection
      keys.push(key);
    }

    return expandedKeys.indexOf(key) !== -1;
  });

  return keys;
}

export function convertDirectoryKeysToNodes(
  treeData: NTree.IDataNode[],
  keys: NTree.TKey[],
  fieldNames: NTree.IFieldNames
) {
  const restKeys: NTree.TKey[] = [...keys];
  const nodes: NTree.IDataNode[] = [];
  traverseNodesKey(treeData, fieldNames, (key: NTree.TKey | null, node: NTree.IDataNode) => {
    const index = restKeys.indexOf(key!);
    if (index !== -1) {
      nodes.push(node);
      restKeys.splice(index, 1);
    }

    return !!restKeys.length;
  });
  return nodes;
}

function traverseNodesKey(
  treeData: NTree.IDataNode[],
  fieldNames: NTree.IFieldNames,
  callback: (key: NTree.TKey | number | null, node: NTree.IDataNode) => boolean
) {
  function processNode(dataNode: NTree.IDataNode) {
    const key = dataNode[fieldNames.key!];
    const children = dataNode[fieldNames.children!];
    if (callback(key, dataNode) !== false) {
      traverseNodesKey(children || [], fieldNames, callback);
    }
  }

  treeData.forEach(processNode);
}
